// FF-DOCK-3 — register the shell tour starter so sidebar (and peers) can
// emit fireflyTourRequestEvent + start the same tourSession engine.

import type { FireflyTourArtifact, FireflyTourTrigger } from "./tourTypes";

type FireflyTourStarter = (
  artifact: FireflyTourArtifact,
  trigger: FireflyTourTrigger,
) => void;

let starter: FireflyTourStarter | null = null;

export function registerFireflyTourStarter(next: FireflyTourStarter): () => void {
  starter = next;
  return () => {
    if (starter === next) starter = null;
  };
}

export function invokeFireflyTourStarter(
  artifact: FireflyTourArtifact,
  trigger: FireflyTourTrigger,
): boolean {
  if (!starter) return false;
  starter(artifact, trigger);
  return true;
}
